import { MasterDegree } from "@/lib";
import React, { memo } from "react";
import { Label } from "../ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { format } from "date-fns";
import { EmptyPlaceholderField } from "./partials/EmptyPlaceholderField";

export const MasterDegreeDetail = memo(({ data, setDegreeInformation }: { data: MasterDegree | null; setDegreeInformation: React.Dispatch<React.SetStateAction<MasterDegree | null>> }) => {
	if (data === null) {
		return <></>;
	}
	return (
		<div>
			<Dialog
				open={data !== null}
				onOpenChange={() => {
					setDegreeInformation(null);
				}}
			>
				<DialogContent className='max-w-6xl'>
					<DialogHeader>
						<DialogTitle>Thông Tin Chi Tiết Bằng Thạc Sĩ </DialogTitle>
					</DialogHeader>
					<div className='grid grid-cols-1 gap-3 h-[50dvh] overflow-y-scroll px-1 pb-4'>
						<div className='grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-3'>
							<div className='col-span-1 text-red-600 font-bold'>Thông tin cá nhân</div>
							<div>
								<Label className='mb-1'>Mã sinh viên</Label>
								<EmptyPlaceholderField data={data.studentId} />
							</div>
							<div>
								<Label className='mb-1'>Họ và tên</Label>
								<div style={{ 'textTransform': 'capitalize' }}>
									<EmptyPlaceholderField data={data.studentName} />
								</div>
							</div>
							<div>
								<Label className='mb-1'>Ngày sinh</Label>
								<EmptyPlaceholderField data={data.dateOfBirth ? format(data.dateOfBirth as unknown as Date, "dd/MM/yyyy") : ""} />
							</div>
							<div>
								<Label className='mb-1'>Giới tính</Label>
								<EmptyPlaceholderField data={data.gender} />
							</div>
							<div>
								<Label className='mb-1'>Nơi sinh</Label>
								<EmptyPlaceholderField data={data.placeOfBirth} />
							</div>
							<div>
								<Label className='mb-1'>CCCD</Label>
								<EmptyPlaceholderField data={data.cccd} />
							</div>
							<div>
								<Label className='mb-1'>Mã dân tộc</Label>
								<EmptyPlaceholderField data={data.ethnicCode} />
							</div>
							<div>
								<Label className='mb-1'>Dân tộc</Label>
								<EmptyPlaceholderField data={data.ethnicity} />
							</div>
							<div>
								<Label className='mb-1'>Mã quốc tịch</Label>
								<EmptyPlaceholderField data={data.nationalityCode} />
							</div>
							<div>
								<Label className='mb-1'>Quốc tịch</Label>
								<EmptyPlaceholderField data={data.nationality} />
							</div>

							<div className='col-span-1 text-red-600 font-bold'>Thông tin học tập và tốt nghiệp</div>
							<div>
								<Label className='mb-1'>Ngành/Chuyên ngành</Label>
								<EmptyPlaceholderField data={data.major} />
							</div>
							<div>
								<Label className='mb-1'>Trình độ</Label>
								<EmptyPlaceholderField data={"Thạc sĩ"} />
							</div>
							<div>
								<Label className='mb-1'>Hình thức đào tạo</Label>
								<EmptyPlaceholderField data={data.trainingMode} />
							</div>
							<div>
								<Label className='mb-1'>Khóa học</Label>
								<EmptyPlaceholderField data={data.course} />
							</div>
							<div>
								<Label className='mb-1'>Mã ngành</Label>
								<EmptyPlaceholderField data={data.majorCode} />
							</div>
						</div>
						<div className='grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-3'>
							<div className='col-span-1 text-red-600 font-bold'>Thông tin cấp bằng</div>
							<div>
								<Label className='mb-1'>Số quyết định công nhận</Label>
								<EmptyPlaceholderField data={data.recognitionDecisionNumber} />
							</div>
							<div>
								<Label className='mb-1'>Số vào sổ cấp bằng</Label>
								<EmptyPlaceholderField data={data.registrationNumber} />
							</div>
							<div>
								<Label className='mb-1'>Số hiệu văn bằng</Label>
								<EmptyPlaceholderField data={data.degreeNumber} />
							</div>
							<div>
								<Label className='mb-1'>Năm tốt nghiệp</Label>
								<EmptyPlaceholderField data={data.graduationYear} />
							</div>
							<div>
								<Label className='mb-1'>Người ký</Label>
								<EmptyPlaceholderField data={data.signedBy} />
							</div>
							<div>
								<Label className='mb-1'>Chức danh người ký</Label>
								<EmptyPlaceholderField data={data.signerTitle} />
							</div>
							<div>
								<Label className='mb-1'>Ngày ký</Label>
								<EmptyPlaceholderField data={data.signDate ? format(data.signDate as unknown as Date, "dd/MM/yyyy") : ""} />
							</div>
							<div>
								<Label className='mb-1'>Mã loại yêu cầu</Label>
								<EmptyPlaceholderField data={data.requestTypeId} />
							</div>
							<div>
								<Label className='mb-1'>Ngày bảo vệ</Label>
								<EmptyPlaceholderField data={data.defenseDate ? format(data.defenseDate as unknown as Date, "dd/MM/yyyy") : ""} />
							</div>
							<div>
								<Label className='mb-1'>Loại yêu cầu</Label>
								<EmptyPlaceholderField data={data.requestType} />
							</div>
							<div className='md:col-span-1 lg:col-span-1'>
								<Label className='mb-1'>Ghi chú</Label>
								<EmptyPlaceholderField data={data.notes} />
							</div>
							<div className='col-span-1 text-red-600 font-bold'>Trạng thái đồng bộ</div>
							<div>
								<Label className='mb-1'>Trạng thái</Label>
								<EmptyPlaceholderField data={data.status} />
							</div>
						</div>
					</div>
				</DialogContent>
			</Dialog>
		</div>
	);
});
